<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">订单详情</span>
      </div>

      <div v-if="waitConfirm" style="border: 1px solid red">
        <div class="clearfix"
             style="border-style: none;border-bottom:1px solid red;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #000000; font-size: 1rem">试客已提交评价，请确认评价</span>
        </div>
        <el-row style="margin: 2%">
          <el-col :span="24">
            <el-button type="primary" @click="waitConfirmFuncation">确认评价</el-button>
            <el-button v-if="isManangerAndStatusConfirm"  type="primary" @click="rejectReviewStatus">拒绝评价</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 后置评价 start -->
      <div style="border: 1px solid red; margin-top: 20px;" v-show="isShowEditReview">
        <el-form ref="reviewDataForm" :model="reviewDataForm" label-position="right" label-width="120px" v-loading.fullscreen.lock="fullscreenLoading">
          <div class="clearfix"
               style="border-style: none;border-bottom:1px solid red;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
            <span style="color: #000000; font-size: 1rem">评价信息</span>
          </div>
          <el-form-item label="好评类型：" style="margin-left: 10%;">
            <el-radio-group v-model="reviewDataForm.taskChecked" @change="taskClassChange">
              <el-radio :label="1">指定文字好评任务
              </el-radio>
              <el-radio :label="2">指定图片好评任务
              </el-radio>
              <el-radio :label="3">指定视频好评任务
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="服务费：" style="margin-left: 10%;">
            <span style="color: red">{{ serviceMoney }}</span>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="评论内容：" style="margin-left: 10%;">
            <el-input v-model="reviewDataForm.reviewContent"
                      placeholder="指定评价内容" style="width: 80%;margin: 1% 0;"></el-input>
          </el-form-item>
          <div v-if="reviewDataForm.taskChecked != 1">
            <div v-if="reviewDataForm.taskChecked == 3">
              <el-divider></el-divider>
              <el-form-item label="好评视频：" style="margin-left: 10%; margin-top: 10px;">
                <el-row :gutter="0" class="itemCls">
                  <el-col :span="24" id="videoTag">
                    <el-form-item label-width="1%" style="margin-bottom: 10px;">
                      <el-upload
                          action="https://api.weiquanai.com/taskservice/file/upload"
                          :headers="myheader"
                          :show-file-list="false"
                          accept="video/mp4"
                          :before-upload="beforeUpload"
                          :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:reviewDataForm, videoIndex:0})"
                          :on-remove="handleAvatarRemove">
                        <video v-if="isVideoShow(reviewDataForm, 0)" width="220" height="220" controls>
                          <source :src="getVideoUrl(reviewDataForm, 0)" type="video/mp4">
                        </video>
                        <i v-else class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <el-form-item label="好评晒图：" style="margin-left: 10%; margin-top: 10px;">
              <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:reviewDataForm, imgIndex:0})"
                        :on-remove="handleAvatarRemove">
                      <div v-if="isImageShow(reviewDataForm, 0)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(reviewDataForm, 0)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleAvatarRemove(getImageUrl(reviewDataForm, 0))"></el-button>
                      </div>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:reviewDataForm, imgIndex:1})"
                        :on-remove="handleAvatarRemove">
                      <div v-if="isImageShow(reviewDataForm, 1)" style="width: 100%;position: relative;">
                        <img  :src="getImageUrl(reviewDataForm, 1)" class="avatar">
                        <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleAvatarRemove(getImageUrl(reviewDataForm, 1))"></el-button>
                      </div>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:reviewDataForm, imgIndex:2})"
                        :on-remove="handleAvatarRemove">
                      <div v-if="isImageShow(reviewDataForm, 2)" style="width: 100%;position: relative;">
                        <img  :src="getImageUrl(reviewDataForm, 2)" class="avatar">
                        <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleAvatarRemove(getImageUrl(reviewDataForm, 2))"></el-button>
                      </div>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:reviewDataForm, imgIndex:3})"
                        :on-remove="handleAvatarRemove">
                      <div v-if="isImageShow(reviewDataForm, 3)" style="width: 100%;position: relative;">
                        <img  :src="getImageUrl(reviewDataForm, 3)" class="avatar">
                        <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleAvatarRemove(getImageUrl(reviewDataForm, 3))"></el-button>
                      </div>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:reviewDataForm, imgIndex:4})"
                        :on-remove="handleAvatarRemove">
                      <div v-if="isImageShow(reviewDataForm, 4)" style="width: 100%;position: relative;">
                        <img  :src="getImageUrl(reviewDataForm, 4)" class="avatar">
                        <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleAvatarRemove(getImageUrl(reviewDataForm, 4))"></el-button>
                      </div>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <el-form-item label-width="20%" style="margin-left: 10%; margin: 10px 0;">
            <el-button type="primary" @click="addReview">添加好评</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- end -->

      <div v-show="isAddressShow">
        <div style="border: 1px solid red;margin-top: 20px;">
          <el-form ref="reviewDataForm" :model="expressDataForm" label-position="right" label-width="120px">
            <div class="clearfix"
                 style="border-style: none;border-bottom:1px solid red;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
              <span style="color: red; font-size: 1rem">确认发货信息</span>
            </div>
            <div>
              <el-row :gutter="5" style="margin-bottom: 5px;">
                <el-col :span="8">
                  <el-form-item label="平台订单号：">
                    <el-input v-model="expressDataForm.plateformNumber" @input='change'></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="试客平台实付：">
                    <el-input v-model="expressDataForm.realyPayMoney" @input='change'></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <el-button type="primary" @click="updateSendShip">修改信息</el-button>
                    <el-button type="primary" @click="confirmSendShip">确认发货</el-button>
                    <el-button type="primary" @click="handleRejectCustomerOrder">驳回</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="5" style="margin: 5px 0;">
                <el-col :span="8">
                  <el-form-item label="订单核验结果: ">
                    <span
                        style="color: red;">{{ expressDataForm.verfiyResult ? expressDataForm.verfiyResult : "任务店铺尚未授权" }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否淘客订单：">
                    <span style="color: red;">{{ isTaoOrder(expressDataForm.isTaobao) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-button type="primary">核验</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>

        <div style="border: 1px solid red; margin-top: 20px;">
          <el-form ref="reviewDataForm" :model="expressAddressForm" label-position="right" label-width="120px">
            <div class="clearfix"
                 style="border-style: none;border-bottom:1px solid red;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
              <span style="color: red; font-size: 1rem">收货地址</span>
            </div>
            <div>
              <el-row :gutter="5" style="margin-bottom: 5px; margin-right: 2%;">
                <el-col :span="6">
                  <el-form-item label="收件人：">
                    <el-input v-model="expressAddressForm.userName" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="手机：">
                    <el-input v-model="expressAddressForm.phoneNumber" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="电话：">
                    <el-input v-model="expressAddressForm.telPhone" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邮编：">
                    <el-input v-model="expressAddressForm.zipNumber" readonly></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="5" style="margin: 5px 0; margin-right: 2%;">
                <el-col :span="6">
                  <el-form-item label="省：">
                    <el-input v-model="expressAddressForm.province" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市：">
                    <el-input v-model="expressAddressForm.city" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="区：">
                    <el-input v-model="expressAddressForm.area" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="5" style="margin: 5px 0; margin-right: 2%;">
                <el-col :span="18">
                  <el-form-item label="详细地址：">
                    <el-input v-model="expressAddressForm.addressDetail" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-show="false">
                  <el-button type="primary">保存收货地址</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>

      <table cellspacing="0" cellpadding="0" width="100%" style="margin-top: 20px">
        <tr style="background-color: lightgray">
          <th style="text-align: left;" colspan="5">
            <span style="margin: 10px">订单详情信息</span>
          </th>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">订单编号</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{
                baseTableData.orderNumbers
              }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">订单状态</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.orderStatus }}</span>
          </td>
        </tr>
        <tr v-show="isAdminRole && isShowReback(baseTableData.orderStatus)">
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <el-button  type="text" style="color: red;" @click="rebackPondOrCancelOrder(baseTableData.id, false)">订单回池</el-button>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center;">
            <el-button type="text" style="color: red;margin-left: -30px" @click="rebackPondOrCancelOrder(baseTableData.id, true)">订单回池取消</el-button>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">任务ID</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{
                baseTableData.taskId
              }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">任务简称</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.taskSimpleName }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">任务类型</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.taskTypeName }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">开始时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.startTime }}</span>
          </td>
        </tr>
        <!-- 隔天任务begin -->
        <tr v-show="baseTableData.taskTypeId == 3">
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">隔天开始时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.buyBeginTime }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">隔天结束时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.buyEndTime }}</span>
          </td>
        </tr>
        <!-- end -->
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">店铺名称</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.shopName }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">目标商品</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.goodName }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2"  style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:10%;text-align: right;font-weight: bolder;vertical-align: top">主商品链接</span>
            <span style="width: 2%;vertical-align: top">：</span>
            <span style="width:88%;text-align: left;word-break : break-all;overflow:hidden; "><a :href="b2cGoods.goodsUrl" target="_blank">{{ b2cGoods.goodsUrl }}</a> </span>
          </td>
        </tr>
        <tr v-for="item in goodsInfos" :key="item.id" v-if="goodsInfos !=null&&goodsInfos.length>0">
          <td colspan="2" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:10%;text-align: right;font-weight: bolder;vertical-align: top">副商品链接</span>
            <span style="width: 2%;vertical-align: top">：</span>
            <span style="width:88%;text-align: left;word-break : break-all;overflow:hidden; " ><a :href="item.goodUrl" target="_blank">{{ item.goodUrl }}</a> </span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">关键字类型</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.taskClassStr }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">关键字</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.wordKey }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">颜色尺码</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.colorSize }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">备用关键词</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{baseTableData.backWord}}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">商家账号</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{baseTableData.businessName}}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">接单试客</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.customerNum }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">接单帐户</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.customerAccount }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">提问</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.questionString }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">答案</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.answerString }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">平台订单号</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.plateformNumber }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">试客平台实付</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.realyPayMoney }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">本金</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.money }}
              <span v-if="baseTableData.expressMoney!=null&&parseFloat(baseTableData.expressMoney)>0" style="color: red">(包含物流费用{{baseTableData.expressMoney}}元)</span>
            </span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">服务费总额</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.totalServiceMoney }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">做单时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.makeyOrderTime }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">付款时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;">{{ baseTableData.payMoneyTime }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">完成时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; ">{{ baseTableData.finishTime }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">本金返款状态</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; color: red;">{{ baseTableData.moneyReturnStatus ? "已返款" : "未返款" }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">本金返款时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;color: red;">{{ baseTableData.moneyReturnTime }}</span>
          </td>
        </tr>
        <tr>
          <td width="30%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">佣金返款状态</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left; color: red;">{{ baseTableData.comissionReturnStatus ? "已返款" : "未返款" }}</span>
          </td>
          <td width="70%" style="border-left-style:none;text-align: center">
            <span style="width:35%;text-align: right;font-weight: bolder;vertical-align: top">佣金返款时间</span>
            <span style="width: 5%;vertical-align: top">：</span>
            <span style="width:60%;text-align: left;color: red;">{{ baseTableData.comissionReturnTime }}</span>
          </td>
        </tr>
      </table>

      <table cellspacing="0" cellpadding="0" width="100%" style="margin-top: 20px">
        <tr style="background-color: lightgray">
          <th style="text-align: left;" colspan="5">
            <span style="margin: 10px">增值服务: <span style="color: red">{{ addSerPriceTotal() }}</span></span>
          </th>
        </tr>
        <tr v-for="(attachItem, index) in tableAddData">
          <td width="100%" style="border-right-style:none;text-align: center;padding: 2px;">
            <span
                style="width:20%;text-align: right;font-weight: bolder;vertical-align: top">{{
                attachItem.attarchKey
              }}</span>
            <span style="width: 3%;vertical-align: top" v-show="!isTestStrEmpty(attachItem.attarchKey)">：</span>
            <span style="width:22%;text-align: left; ">{{ attachItem.attarchValue }}</span>
            <span style="width:50%;text-align: left;color: red"> {{getAttachLimit(attachItem.attarchKey)}}</span>
          </td>
        </tr>
      </table>

      <div style="border: 1px solid gray;margin-top: 20px" id="reviewstyle">
        <div class="clearfix"
             style="border-style: none;border-bottom:1px solid gray;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #000000; font-size: 1rem">评价</span>
        </div>
        <div v-if="isShowReivew">
          <el-form ref="reviewDataForm" :model="reviewDataForm" label-position="right" label-width="120px">
            <el-form-item label="指定文字">
              <el-input v-if="isShow" size="small" v-model="orderReviewInfo.reviewContent"
                        placeholder="请输入内容"></el-input>
              <span v-else>{{ orderReviewInfo.reviewContent }}</span>
            </el-form-item>
            <div v-if="isVideoShow(orderReviewInfo, 0) || isShow">
              <el-divider></el-divider>
              <el-form-item label="好评视频">
                <el-row :gutter="0" class="itemCls">
                  <el-col :span="24" id="videoTagShow">
                    <el-form-item label-width="1%" style="margin-bottom: 10px;">
                      <el-upload
                          action="https://api.weiquanai.com/taskservice/file/upload"
                          :headers="myheader"
                          :show-file-list="false"
                          accept="video/mp4"
                          :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:orderReviewInfo, videoIndex:0})"
                          :on-remove="handleAvatarRemove"
                          :disabled="!isShow">
                        <video v-if="isVideoShow(orderReviewInfo, 0)" width="220" height="220" controls>
                          <source :src="getVideoUrl(orderReviewInfo, 0)" type="video/mp4">
                        </video>
                        <i v-else class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <el-form-item label="好评图片">
              <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:orderReviewInfo, imgIndex:0})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(orderReviewInfo, 0)" :src="getImageUrl(orderReviewInfo, 0)" class="avatar"
                           @click="handlePictureCardPreview(0)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:orderReviewInfo, imgIndex:1})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(orderReviewInfo, 1)" :src="getImageUrl(orderReviewInfo, 1)" class="avatar"
                           @click="handlePictureCardPreview(1)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:orderReviewInfo, imgIndex:2})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(orderReviewInfo, 2)" :src="getImageUrl(orderReviewInfo, 2)" class="avatar"
                           @click="handlePictureCardPreview(2)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:orderReviewInfo, imgIndex:3})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(orderReviewInfo,3)" :src="getImageUrl(orderReviewInfo, 3)" class="avatar"
                           @click="handlePictureCardPreview(3)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:orderReviewInfo, imgIndex:4})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(orderReviewInfo, 4)" :src="getImageUrl(orderReviewInfo, 4)" class="avatar"
                           @click="handlePictureCardPreview(4)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <!--<el-divider></el-divider>
            <el-form-item style="margin-bottom: 5px;">
              <el-button type="primary" @click="updateIsShow">修改评价</el-button>
            </el-form-item>-->
          </el-form>
        </div>
        <div style="position: relative">
          <el-row>
            <el-col :span="24" style="text-align: center">
              <div style="background-color: lightgray;text-align: left; padding-left: 2%;color: #000000;height: 33px;line-height: 33px;">试客评价截图：</div>
              <div v-for="(imgIt, index) in orderReviewImgs" :key="index" style="margin: 5px; width: 320px;display: flex;flex-direction: column;justify-items: center;align-items: center;border: #2c2c2c solid 1px">
                <div>评价图片{{index}}</div>
                <el-image  :src="imgIt" style="width: 260px; height: 260px;margin: 2%;" :preview-src-list="orderReviewImgs" >
              </el-image>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--追评-->
        <div class="clearfix"
             style="border-style: none;border-bottom:1px solid gray;background-color: lightgray;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #000000; font-size: 1rem">追评</span>
        </div>
        <div v-if="isShowExtraReivew">
          <el-form ref="reviewDataForm" :model="reviewDataForm" label-position="right" label-width="120px">
            <el-form-item label="指定文字">
              <el-input v-if="isShow" size="small" v-model="extraReviewInfoVo.reviewContent"
                        placeholder="请输入内容"></el-input>
              <span v-else>{{ extraReviewInfoVo.reviewContent }}</span>
            </el-form-item>
            <div v-if="isVideoShow(extraReviewInfoVo, 0) || isShow">
              <el-divider></el-divider>
              <el-form-item label="好评视频">
                <el-row :gutter="0" class="itemCls">
                  <el-col :span="24" id="videoTagShow">
                    <el-form-item label-width="1%" style="margin-bottom: 10px;">
                      <el-upload
                          action="https://api.weiquanai.com/taskservice/file/upload"
                          :headers="myheader"
                          :show-file-list="false"
                          accept="video/mp4"
                          :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:extraReviewInfoVo, videoIndex:0})"
                          :on-remove="handleAvatarRemove"
                          :disabled="!isShow">
                        <video v-if="isVideoShow(extraReviewInfoVo, 0)" width="220" height="220" controls>
                          <source :src="getVideoUrl(extraReviewInfoVo, 0)" type="video/mp4">
                        </video>
                        <i v-else class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <el-form-item label="好评图片">
              <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:extraReviewInfoVo, imgIndex:0})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(extraReviewInfoVo, 0)" :src="getImageUrl(extraReviewInfoVo, 0)" class="avatar"
                           @click="handlePictureCardExtraPreview(0)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:extraReviewInfoVo, imgIndex:1})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(extraReviewInfoVo, 1)" :src="getImageUrl(extraReviewInfoVo, 1)" class="avatar"
                           @click="handlePictureCardExtraPreview(1)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:extraReviewInfoVo, imgIndex:2})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(extraReviewInfoVo, 2)" :src="getImageUrl(extraReviewInfoVo, 2)" class="avatar"
                           @click="handlePictureCardExtraPreview(2)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:extraReviewInfoVo, imgIndex:3})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(extraReviewInfoVo,3)" :src="getImageUrl(extraReviewInfoVo, 3)" class="avatar"
                           @click="handlePictureCardExtraPreview(3)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label-width="6%">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleReviewSuccess.bind(null, {index: index, data:extraReviewInfoVo, imgIndex:4})"
                        :on-remove="handleAvatarRemove"
                        :disabled="!isShow">
                      <img v-if="isImageShow(extraReviewInfoVo, 4)" :src="getImageUrl(extraReviewInfoVo, 4)" class="avatar"
                           @click="handlePictureCardExtraPreview(4)">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <!--<el-divider></el-divider>
            <el-form-item style="margin-bottom: 5px;">
              <el-button type="primary" @click="updateIsShow">修改评价</el-button>
            </el-form-item>-->
          </el-form>
        </div>
        <div style="position: relative">
          <el-row>
            <el-col :span="24" style="text-align: center">
              <div style="background-color: lightgray;text-align: left; padding-left: 2%;color: #000000;height: 33px;line-height: 33px;">试客追评截图：</div>
              <div v-for="(imgIt, index) in orderExtraReviewImgs" :key="index" style="margin: 5px; width: 320px;display: flex;flex-direction: column;justify-items: center;align-items: center;border: #2c2c2c solid 1px">
                <div>评价图片{{index}}</div>
                <el-image  :src="imgIt" style="width: 260px; height: 260px;margin: 2%;" :preview-src-list="orderExtraReviewImgs" >
                </el-image>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <table cellspacing="0" cellpadding="0" width="100%" style="margin-top: 20px" v-if="verifyCodeImages!= null && verifyCodeImages.length >0">
        <tr style="background-color: lightgray">
          <th style="text-align: left;" colspan="5">
            <span style="margin: 10px">核验码信息</span>
          </th>
        </tr>
        <tr v-for="it in verifyCodeImages">
          <td width="100%" style="border-right-style:none;text-align: center;padding: 2px;">
            <div class="demo-image__preview">
              <el-image
                  :src="it"
                  style="width: 260px; height: 260px;margin: 2%;"
                  :preview-src-list="verifyCodeImages">
              </el-image>
            </div>
          </td>
        </tr>
      </table>

      <table cellspacing="0" cellpadding="0" width="100%" style="margin-top: 20px">
        <tr style="background-color: lightgray">
          <th style="text-align: left;" colspan="5">
            <span style="margin: 10px">截图信息</span>
          </th>
        </tr>
        <tr>
          <td width="100%" style="border-right-style:none;text-align: center;padding: 2px;">
            <div style="display: grid;grid-template-columns: repeat(3, 1fr);gap: 5px;  width: 100%;justify-items: center;align-items: center">
            <div class="demo-image__preview" v-for="it in payImages">
              <el-image
                  fit="cover"
                  :src="it"
                  style="width: 260px; height: 260px;margin: 2%;"
                  :preview-src-list="payImages">
              </el-image>
            </div>
            </div>
          </td>
        </tr>
      </table>
    </el-card>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="230px">
        <el-form-item label="备注">
          <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getTokenRoleCode, isObjectEmpty, isStrEmpty} from '@/lib/utils';
import {
  confirmChaseStatus,
  getOrderTaskDetail,
  getReciveOrderAddress, rebackPondOrCancelOrder,
  updateOrderMoney,
  updateOrderStatus
} from "../../api/b2cbusiness/b2c_orderlist";
import {FloatAdd, getJwtToken} from "../../lib/utils";
import {getAllReviewServiceMoney} from "../../api/b2cbusiness/b2c_servicemoney";
import {addTaskDetailContent} from "../../api/b2cbusiness/b2c_tasklist";
import {serviceAttach} from "../../lib/dictToChness";

export default {
  name: "TaskOrderDetail",
  mixins: [MixinCUD],
  data() {
    return {
      fullscreenLoading: false,
      myheader: {
        JWTHeaderName: ""
      },
      dialogImageUrl: '',
      dialogVisible: false,
      reviewDataForm: {
        taskChecked: 1,
        imageUrls: [],
        videoUrls: [],
        reviewContent: "",
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      expressDataForm: {},
      expressAddressForm: {},
      orderReviewInfo: {
        reviewContent: "",
      },
      extraReviewInfoVo: {
        reviewContent: "",
      },
      orderReviewImgs:[],
      orderExtraReviewImgs:[],
      isHaveReview: true,
      serviceMoney: 0.0,
      commissionMoney: 0.0,
      disabled: false,
      isShow: false,
      isShowAddr: false,
      baseTableData: {},
      payImages: [],
      verifyCodeImages:[],
      tableAddData: [
        {
          titleKeys: "自动验号",
          titleValues: "0.30"
        },
        {
          titleKeys: "允许使用优惠券及红包",
          titleValues: "0.00"
        },
        {
          titleKeys: "需要假聊",
          titleValues: "0.00"
        },
        {
          titleKeys: "货比足迹",
          titleValues: "0.00"
        },
        {
          titleKeys: "浏览目标宝贝",
          titleValues: "0.00"
        },
        {
          titleKeys: "核对商品链接",
          titleValues: "0.00"
        },
      ],
      queryForm: {
        isneedReview: 0,
      },
      serviceAttachMap:null,
      checkList: [],
      checkList1: [],
      b2cGoods: null,
      goodsInfos: []
    }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    if (!isStrEmpty(this.$route.query.taskNumbers)){
      sessionStorage.setItem("taskNumbers", this.$route.query.taskNumbers);
    }

    //新增详情保留orderId
    if (!isStrEmpty(this.$route.query.orderId)){
      sessionStorage.setItem("orderId", this.$route.query.orderId);
    }

    getOrderTaskDetail({orderId: isStrEmpty(this.$route.query.orderId)?sessionStorage.getItem("orderId"):this.$route.query.orderId,
      orderNum:isStrEmpty(this.$route.query.taskNumbers)?sessionStorage.getItem("taskNumbers"):this.$route.query.taskNumbers}).then(res => {
      if (res.success) {
        this.isHaveReview = res.data.isHaveReview;
        this.baseTableData = res.data.orderDetailVo;
        this.tableAddData = res.data.serviceAttarchVos;
        this.orderReviewInfo = res.data.orderReviewInfoVo;
        this.extraReviewInfoVo = res.data.extraReviewInfoVo;
        this.serviceAttachMap = res.data.serviceAttarchBeanArray;
        this.b2cGoods = res.data.b2cGoods;
        this.goodsInfos = res.data.goodsInfos;
        this.orderReviewImgs = res.data.orderReviewImgs;
        this.orderExtraReviewImgs = res.data.orderExtraReviewImgs;
        this.payImages = res.data.payInfoImages;
        this.verifyCodeImages = res.data.verifyCodeImages;
        this.setExpressValue(res.data.orderDetailVo);
        console.log(this.orderExtraReviewImgs)
        getReciveOrderAddress({
          orderId: this.baseTableData.id,
          plateUserName: this.baseTableData.customerAccount
        }).then(res => {
          if (res.success) {
            this.expressAddressForm = res.data;
          }
        });
        this.$forceUpdate();
      }
    });

    getAllReviewServiceMoney('20210002').then(res => {
      if (res.success) {
        this.serviceMoney = res.data[0].serviceMoney;
      }
    });
  },
  activated() {
    getOrderTaskDetail({orderId: isStrEmpty(this.$route.query.orderId)?sessionStorage.getItem("orderId"):this.$route.query.orderId, orderNum:sessionStorage.getItem("taskNumbers")}).then(res => {
      if (res.success) {
        this.isHaveReview = res.data.isHaveReview;
        this.baseTableData = res.data.orderDetailVo;
        this.tableAddData = res.data.serviceAttarchVos;
        this.orderReviewInfo = res.data.orderReviewInfoVo;
        this.extraReviewInfoVo = res.data.extraReviewInfoVo;
        this.serviceAttachMap = res.data.serviceAttarchBeanArray;
        this.b2cGoods = res.data.b2cGoods;
        this.goodsInfos = res.data.goodsInfos;
        this.orderReviewImgs = res.data.orderReviewImgs;
        this.orderExtraReviewImgs = res.data.orderExtraReviewImgs;
        this.payImages = res.data.payInfoImages;
        this.verifyCodeImages = res.data.verifyCodeImages;
        this.setExpressValue(res.data.orderDetailVo);
        console.log(this.orderExtraReviewImgs)
        getReciveOrderAddress({
          orderId: this.baseTableData.id,
          plateUserName: this.baseTableData.customerAccount
        }).then(res => {
          if (res.success) {
            this.expressAddressForm = res.data;
          }
        });
        this.$forceUpdate();
      }
    });
  },
  computed: {
    isAdminRole(){
      return (getTokenRoleCode() == "admin" || getTokenRoleCode() == "cuservices" || getTokenRoleCode() == "returnfinance" || getTokenRoleCode() == "manager")
    },
    isShowReback(){
      return function (orderStatus) {
        return (orderStatus == "待操作" || orderStatus == "待审核")
      }
    },
    getAttachLimit(){
      return function (attachKey) {
        for (let key in serviceAttach){
          if (attachKey == serviceAttach[key].name){
            if (attachKey == "地域限制"){
              let stringTmp = this.serviceAttachMap["localLimitReview"] == 0?"可接单地区":"不可接单地区";
              return stringTmp+"："+this.serviceAttachMap["localInfosChecked"];
            }else {
              let subKey = Object.keys(serviceAttach[key]).filter(item => !item.includes("name")).pop();
              if (subKey != "localInfosChecked"&&!isStrEmpty(subKey)){
                let res = serviceAttach[key][subKey][this.serviceAttachMap[subKey]];
                if (!isStrEmpty(res)) {
                  return res;
                }
              }
            }
          }
        }
      }
    },
    isShowEditReview(){
      // if (!this.isHaveReview && this.orderReviewImgs != null && this.orderReviewImgs.length >0){
        return !this.isShowReivew && this.baseTableData.orderStatus == "待评价";
      // }else{
      //   return true;
      // }
    },
    isShowReivew(){
      //|| this.baseTableData.orderStatus != "待评价"
      if (this.orderReviewInfo == null){
        return false;
      }else{
        return true;
      }
    },
    isShowExtraReivew(){
      //|| this.baseTableData.orderStatus != "待评价"
      if (isObjectEmpty(this.extraReviewInfoVo)){
        return false;
      }else{
        return true;
      }
    },
    isAddressShow() {
      if (this.baseTableData.orderStatus == "确认发货返款"
          || this.baseTableData.orderStatus == "金额异常") {
        return true;
      } else {
        return false;
      }
    },
    waitConfirm() {
      if (this.baseTableData.orderStatus == "待确认" || this.baseTableData.orderStatus == "追评确认") {
        return true;
      } else {
        return false;
      }
    },
    //新增判断是否追评确认和管理员角色
    isManangerAndStatusConfirm(){
      if (this.baseTableData.orderStatus == "追评确认" && (getTokenRoleCode() == "admin" || getTokenRoleCode() == "manager")) {
        return true;
      } else {
        return false;
      }
    },
    isTaoOrder() {
      return function (data) {
        if (data == undefined) {
          return "未检测";
        } else {
          return data ? "是" : "否";
        }
      }
    },
    isImageShow() {
      return function (val, index) {
        if (val.imageUrls != undefined && val.imageUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getImageUrl() {
      return function (val, index) {
        console.log(val, index);
        if (val.imageUrls != undefined && val.imageUrls.length > 0) {
          return val.imageUrls[index];
        }
        return null;
      }
    },
    isVideoShow() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getVideoUrl() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > 0) {
          return val.videoUrls[index];
        }
        return null;
      }
    },
  },
  methods: {
    rebackPondOrCancelOrder(orderId, cancelOrder){
      this.$confirm("确认回池或者回池取消订单?").then(_ => {
            rebackPondOrCancelOrder(orderId, cancelOrder).then(res => {
              if (res.success) {
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
       });
    },
    change(){
      this.$forceUpdate();
    },
    handleRejectCustomerOrder(){
      this.dialogFormVisible = true;
      this.dialogForm.orderId  = this.baseTableData.id;
      this.dialogTitle = title
    },
    addData(){
      this.$confirm("确定驳回订单?")
          .then(_ => {
            updateOrderStatus({orderId: this.dialogForm.orderId, stepNum: 2, orderStatus: "待操作", remarks:this.dialogForm.remarks}).then(res => {
              if (res.success) {
                this.handleCloseDialog();
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          });
    },
    handlePictureCardPreview(imgIndex) {
      this.dialogImageUrl = this.getImageUrl(this.orderReviewInfo, imgIndex);
      this.dialogVisible = true;
    },
    handlePictureCardExtraPreview(imgIndex) {
      this.dialogImageUrl = this.getImageUrl(this.extraReviewInfoVo, imgIndex);
      this.dialogVisible = true;
    },
    updateSendShip(){
      this.$confirm("确定修改订单或金额? 修改后为确认发货状态！").then(_ =>{
        updateOrderMoney({orderId: this.baseTableData.id,
          plateformNumbers:this.expressDataForm.plateformNumber,
          updateMoney: this.expressDataForm.realyPayMoney,
          //statusStr: !isStrEmpty(this.baseTableData.statusStr)&&this.baseTableData.statusStr =="金额异常" >0?"确认发货返款":"待评价",
          statusStr: "确认发货返款",
          remarks: ""}).then(res => {
          if (res.success) {
            this.$message.success("修改成功！")
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    confirmSendShip() {
      updateOrderStatus({orderId: this.baseTableData.id, stepNum: 4, orderStatus: "待评价"}).then(res => {
        if (res.success) {
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    waitConfirmFuncation() {
      if (this.baseTableData.orderStatus == "待确认") {
        updateOrderStatus({orderId: this.baseTableData.id, stepNum: 6, orderStatus: "已完成"}).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }else if (this.baseTableData.orderStatus == "追评确认"){
        confirmChaseStatus({orderId: this.baseTableData.id, orderStatus: "已完成"}).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }
    },
    //新增判断拒绝追评
    rejectReviewStatus(){
      confirmChaseStatus({orderId: this.baseTableData.id, orderStatus: "追评"}).then(res => {
        if (res.success) {
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    setExpressValue(data) {
      this.expressDataForm.plateformNumber = data.plateformNumber;
      this.expressDataForm.realyPayMoney = data.realyPayMoney;
    },
    updateIsShow() {
      this.isShow = true;
    },
    addReview() {
      this.fullscreenLoading = true
      let taskClass = '20210002';
      if (this.reviewDataForm.taskChecked == 2) {
        taskClass = '20210003';
      } else if (this.reviewDataForm.taskChecked == 3) {
        taskClass = '20210004';
      }
      //新增一个字段订单ID
      this.reviewDataForm.orderId = this.$route.query.orderId;
      this.reviewDataForm.orderNumber = this.$route.query.taskNumbers;
      this.reviewDataForm.taskDetailId = this.baseTableData.taskDetailId;
      this.reviewDataForm.taskClass = taskClass;
      this.reviewDataForm.serviceMoney = this.serviceMoney
      this.reviewDataForm.commissionMoney = this.commissionMoney
      //this.reviewDataForm.imageUrls.push.apply(this.reviewDataForm.videoUrls);
      //添加确认对话框
      this.$confirm("确认添加评价？").then(_=>{
        addTaskDetailContent(this.reviewDataForm).then(res => {
          if (res.success) {
            this.getData();
            this.fullscreenLoading = false
            location.reload()
          }
        }).catch(err => {
          this.fullscreenLoading = false
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    handleAvatarRemove(file) {
      //console.log(file)
      let indx = this.reviewDataForm.imageUrls.findIndex((item)=>item==file);
      this.reviewDataForm.imageUrls.splice(indx, 1)
      //console.log(this.reviewDataForm.imageUrls, indx)
    },
    getData() {
      getOrderTaskDetail({orderId: this.$route.query.orderId, orderNum:this.$route.query.taskNumbers}).then(res => {
        if (res.success) {
          this.isHaveReview = res.data.isHaveReview;
          this.baseTableData = res.data.orderDetailVo;
          this.tableAddData = res.data.serviceAttarchVos;
          this.serviceAttachMap = res.data.serviceAttarchBeanArray;
          this.payInfoImages = res.data.payInfoImages;
          console.log(this.tableAddData)
          this.$forceUpdate();
        }
      });
    },
    handleReviewSuccess(obj, res, file) {
      if (this.reviewDataForm.imageUrls.length < obj.imgIndex) {
        this.reviewDataForm.imageUrls.push(res.data);
      } else {
        this.reviewDataForm.imageUrls.splice(obj.imgIndex, 1, res.data);
      }
    },
    handleReviewVideoSuccess(obj, res, file) {
      this.fullscreenLoading = false
      if (this.reviewDataForm.videoUrls.length < obj.videoIndex) {
        this.reviewDataForm.videoUrls.push(res.data);
      } else {
        this.reviewDataForm.videoUrls.splice(obj.videoIndex, 1, res.data);
      }
    },
    taskClassChange() {
      let taskClass = '20210002';
      if (this.reviewDataForm.taskChecked == 2) {
        taskClass = '20210003';
      } else if (this.reviewDataForm.taskChecked == 3) {
        taskClass = '20210004';
      }
      this.reviewDataForm.taskClass = taskClass
      getAllReviewServiceMoney(taskClass).then(res => {
        if (res.success) {
          this.serviceMoney = res.data[0].serviceMoney
          this.commissionMoney = res.data[0].comissionMoney
        }
      });
    },
    isTestStrEmpty(str) {
      return isStrEmpty(str);
    },
    addSerPriceTotal() {
      let total = 0.0;
      for (let i in this.tableAddData) {
        total = FloatAdd(total, this.tableAddData[i].attarchValue);
      }
      return total;
    },
    beforeUpload(){
      this.fullscreenLoading = true;
    }
  }
}
</script>

<style lang="scss" scoped>
table, table tr th, table tr td {
  border-collapse: collapse;
  border: 1px solid #acacac;
  line-height: 33px;
}

.demo-image__preview{
  width: 320px;
  height: 320px;
  margin: 2%;
  position: relative;
  border: black solid 1px;
}

td span {
  display: inline-block;
}

.el-divider {
  border-top: 1px solid red;
  margin: 0;
}

/deep/ .el-form-item {
  margin-bottom: 0;
}

.boxself {
  border: 1px solid red;
  margin-left: 28%;
  font-size: smaller;
  height: 100%;

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .avatar {
    width: 100px;
    height: 100px;
  }

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }

}

#videoTag {
  /deep/ .el-upload--picture-card {
    width: 220px;
    height: 220px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .avatar {
    width: 220px;
    height: 220px;
  }
}

.itemCls {
  /deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .avatar {
    width: 120px;
    height: 120px;
  }
}

.keywordCls {
  max-height: 30px;
  margin: 5px 2px;
  background-color: lightpink;

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }
}

.contentCls {
  border: 1px solid red;
  border-radius: 5px;
  margin: 5px;

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 1%;
  }
}

.a {
  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item /deep/ .el-form-item__label {
    margin: 2px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 2px;
  }
}

.planCls {
  border: 1px solid red;
  margin: 5px;

  .el-divider {
    margin: 8px 0;
    background: 0 0;
    border-top: 1px solid red;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}

#reviewstyle {
  .el-divider {
    margin: 4px 0;
    background: 0 0;
    border-top: 1px solid gray;
  }
}

.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}

.el-tabs-self {
  position: relative;
  width: 100%;
}

span {
  text-align: center;
}

.tb-edit .el-input {
  display: none
}

.tb-edit .current-row .el-input {
  display: block
}

.tb-edit .current-row .el-input + span {
  display: none
}
</style>
